import { useLocale } from "next-intl";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getMatchesSuspensions } from "@/api/sportEventsNew";
import { SportEventsNewQueryKeys } from "./sportEventsNewQueryKeys";

export const useMatchesSuspensions = ({
  feedType,
  sportType,
  targetUsername,
  page,
  pageSize,
  search,
}: {
  feedType: string;
  sportType?: string;
  targetUsername?: string;
  page: number;
  pageSize: number;
  search?: string;
}) => {
  const lang = useLocale();

  return useQuery({
    queryKey: [
      SportEventsNewQueryKeys.MatchSuspensions,
      feedType,
      sportType,
      targetUsername,
      page,
      pageSize,
      search,
    ],
    enabled: Boolean(sportType),
    // Keep the current page visible while the next page (or a poll) loads, so
    // server-side page changes don't flash the full-screen loading state.
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) =>
      getMatchesSuspensions({
        signal,
        params: {
          feedType,
          sportType,
          lang,
          targetUsername,
          page,
          pageSize,
          search,
        },
      }),
    refetchInterval: feedType === "live" ? 5000 : 60000,
  });
};
